"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
require("react-responsive-modal/styles.css");
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _brokers = _interopRequireDefault(require("./brokers"));
require("./BuyFund.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCircleNotch);
var EVENT_CATEGORY = 'etf';
var EVENT_ACTION_BUY = 'etf buy';
var EVENT_ACTION_LAUNCH = 'etf broker';
var EVENT_ACTION_COMPARE = 'etf compare';
var WT_DIVISIONS = {
  US: 1,
  USDigital: 3
};
var BuyFund = /*#__PURE__*/function (_PureComponent) {
  _inherits(BuyFund, _PureComponent);
  var _super = _createSuper(BuyFund);
  function BuyFund(props) {
    var _this;
    _classCallCheck(this, BuyFund);
    _this = _super.call(this, props);
    _this.handleOpenModal = _this.handleOpenModal.bind(_assertThisInitialized(_this));
    _this.handleCloseModal = _this.handleCloseModal.bind(_assertThisInitialized(_this));
    _this.handleBrokerClick = _this.handleBrokerClick.bind(_assertThisInitialized(_this));
    _this.handleCompareClick = _this.handleCompareClick.bind(_assertThisInitialized(_this));
    _this.handleSubmitWaitlist = _this.handleSubmitWaitlist.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.state = {
      openModal: false,
      fundExists: false,
      showWaitlistSuccess: false,
      showWaitlistLoading: false,
      email: '',
      firstName: '',
      lastName: '',
      stateCode: ''
    };

    // If the compare button should be shown then check if the given ticker exists
    // in the Fund Comparison tool
    if (props.showCompare) {
      _this.checkFundExists();
    }
    return _this;
  }

  // Handle open of modal
  _createClass(BuyFund, [{
    key: "handleOpenModal",
    value: function handleOpenModal() {
      var ticker = this.props.ticker;

      // Tag the event of opening the modal when user clicks the button
      if (window.digitalData) {
        var e = {
          eventName: EVENT_ACTION_BUY,
          eventCategory: EVENT_CATEGORY,
          eventAction: EVENT_ACTION_BUY,
          eventLabel: ticker.toLowerCase(),
          type: 'CustomTagEvent'
        };
        window.digitalData.newEvent(e);
      }
      this.setState({
        openModal: true,
        showWaitlistLoading: false
      });
    }

    // Handle close of modal
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        openModal: false,
        showWaitlistLoading: false
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(fieldName, event) {
      this.setState(_defineProperty({}, fieldName, event.target.value));
    }

    // Handle submit to waitlist
  }, {
    key: "handleSubmitWaitlist",
    value: function handleSubmitWaitlist(event) {
      var _this2 = this;
      var _this$props = this.props,
        dataspanApiUrl = _this$props.dataspanApiUrl,
        ticker = _this$props.ticker;
      var _this$state = this.state,
        firstName = _this$state.firstName,
        lastName = _this$state.lastName,
        email = _this$state.email,
        stateCode = _this$state.stateCode;
      this.setState({
        showWaitlistLoading: true
      });
      var config = {
        method: 'POST',
        url: "".concat(dataspanApiUrl, "/prime/betasignup/"),
        data: {
          email: email,
          firstName: firstName,
          lastName: lastName,
          state: stateCode,
          country: stateCode,
          referringDomain: 'https://www.wisdomtree.com',
          referringDescription: ticker
        }
      };

      // Get the fund data from dataspan
      _axios.default.request(config).then(function (response) {
        if (response.status === 201) {
          _this2.setState({
            showWaitlistSuccess: true,
            showWaitlistLoading: false
          });
        }
      }).catch(function (e) {
        console.log(e);
        _this2.setState({
          showWaitlistLoading: false
        });
      });
      event.preventDefault();
    }

    // Handle click to compare the fund. This opens the Fund Comparison tool
  }, {
    key: "handleCompareClick",
    value: function handleCompareClick() {
      var ticker = this.props.ticker;
      if (window.digitalData) {
        var e = {
          eventName: EVENT_ACTION_COMPARE,
          eventCategory: EVENT_CATEGORY,
          eventAction: EVENT_ACTION_COMPARE,
          eventLabel: ticker.toLowerCase(),
          type: 'CustomTagEvent'
        };
        window.digitalData.newEvent(e);
      }

      // add showcompetitor for Compare Fund button
      var FUND_COMPARISON_URL = '/tools#fund-comparison&tickers=[[TICKER]]&showcompetitors=[[SHOW_COMPETITORS]]&tab=metrics';
      FUND_COMPARISON_URL = FUND_COMPARISON_URL.replace('[[TICKER]]', ticker);
      if (this.props.showCompetitors === true) {
        FUND_COMPARISON_URL = FUND_COMPARISON_URL.replace('[[SHOW_COMPETITORS]]', this.props.showCompetitors);
      } else {
        FUND_COMPARISON_URL = FUND_COMPARISON_URL.replace('[[SHOW_COMPETITORS]]', false);
      }
      window.open(FUND_COMPARISON_URL, '_blank');
    }

    // Handle closure of modal when broker is clicked
  }, {
    key: "handleBrokerClick",
    value: function handleBrokerClick(broker) {
      var ticker = this.props.ticker;

      // Tag the event of clicking the broker link
      if (window.digitalData) {
        var e = {
          eventName: EVENT_ACTION_LAUNCH,
          eventCategory: EVENT_CATEGORY,
          eventAction: EVENT_ACTION_LAUNCH,
          eventLabel: "".concat(broker.name, "|").concat(ticker.toLowerCase()),
          type: 'CustomTagEvent'
        };
        window.digitalData.newEvent(e);
      }
      this.setState({
        openModal: false
      });

      // Open the broker with the ticker provided
      window.open(broker.baseUrl.replace('[TICKER]', ticker.toUpperCase()).replace('[FUNDURL]', window.location.href), '_blank');
    }
  }, {
    key: "renderUsEtfs",
    value: function renderUsEtfs() {
      var _this3 = this;
      var _this$props2 = this.props,
        ticker = _this$props2.ticker,
        brokers = _this$props2.brokers,
        showCompare = _this$props2.showCompare;
      var openModal = this.state.openModal;

      // Set up the broker icons
      var sites = brokers.map(function (broker) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "broker-icon",
          onClick: _this3.handleBrokerClick.bind(_this3, broker),
          key: broker.name
        }, /*#__PURE__*/_react.default.createElement("img", {
          height: "90px",
          src: broker.icon,
          alt: broker.name
        }));
      });
      var compareButton = this.renderCompareButton();
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "buy-fund-app"
      }, ticker !== 'NONE' ? /*#__PURE__*/_react.default.createElement("div", {
        className: "trade-fund"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.handleOpenModal
      }, "HOW TO BUY", ' ', ticker.toUpperCase()), showCompare ? compareButton : null, /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
        open: openModal === true,
        showCloseIcon: true,
        onClose: this.handleCloseModal,
        focusTrapped: false,
        classNames: {
          overlay: 'modal-overlay',
          modal: 'choose-broker-container'
        },
        closeOnOverlayClick: true,
        closeOnEsc: true,
        center: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "choose-broker"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "intro"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "How Can I Buy ", ticker.toUpperCase(), "?"), /*#__PURE__*/_react.default.createElement("p", null, "This is perhaps the most common question we are asked. ETFs are traded on major stock exchanges, much like shares of common stock. They can be bought and sold throughout the trading day through a broker. Brokerage commissions and transaction costs may vary, so be sure to check on these costs with your broker, advisor, or other intermediary."), /*#__PURE__*/_react.default.createElement("p", null, "Click your broker below to trade ", ticker.toUpperCase(), "."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "bold-text"
      }, "You will leave the WisdomTree website when clicking any link below."), ' ', "Hyperlinks on this website are provided as a convenience and we disclaim any responsibility for information, services or products found on the websites linked hereto."), /*#__PURE__*/_react.default.createElement("p", null, "WisdomTree makes no representations, warranties, endorsements, or recommendations regarding any broker, advisor, or other financial intermediary. Ask such entities or persons about any payments from WisdomTree, which may create a conflict of interest influencing such entities or persons to recommend a WisdomTree ETF over another investment.")), /*#__PURE__*/_react.default.createElement("div", {
        className: "brokers"
      }, sites), /*#__PURE__*/_react.default.createElement("div", {
        className: "footnotes"
      }, /*#__PURE__*/_react.default.createElement("p", null))))) : null);
    }

    // Render the form for submitting beta signup
  }, {
    key: "renderWaitlistForm",
    value: function renderWaitlistForm() {
      var _this4 = this;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmitWaitlist,
        className: "waitlist-form"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        value: this.state.firstName,
        onChange: function onChange(event) {
          return _this4.handleInputChange('firstName', event);
        },
        id: "firstName",
        placeholder: "First name",
        required: true
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        value: this.state.lastName,
        onChange: function onChange(event) {
          return _this4.handleInputChange('lastName', event);
        },
        id: "lastName",
        placeholder: "Last name",
        required: true
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "email",
        value: this.state.email,
        onChange: function onChange(event) {
          return _this4.handleInputChange('email', event);
        },
        pattern: "^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$",
        id: "email",
        placeholder: "Email address",
        required: true
      }), /*#__PURE__*/_react.default.createElement("select", {
        id: "stateCode",
        onChange: function onChange(event) {
          return _this4.handleInputChange('stateCode', event);
        },
        required: true
      }, /*#__PURE__*/_react.default.createElement("option", {
        value: ""
      }, "State"), /*#__PURE__*/_react.default.createElement("option", {
        value: "AL"
      }, "Alabama"), /*#__PURE__*/_react.default.createElement("option", {
        value: "AK"
      }, "Alaska"), /*#__PURE__*/_react.default.createElement("option", {
        value: "AZ"
      }, "Arizona"), /*#__PURE__*/_react.default.createElement("option", {
        value: "AR"
      }, "Arkansas"), /*#__PURE__*/_react.default.createElement("option", {
        value: "CA"
      }, "California"), /*#__PURE__*/_react.default.createElement("option", {
        value: "CO"
      }, "Colorado"), /*#__PURE__*/_react.default.createElement("option", {
        value: "CT"
      }, "Connecticut"), /*#__PURE__*/_react.default.createElement("option", {
        value: "DE"
      }, "Delaware"), /*#__PURE__*/_react.default.createElement("option", {
        value: "DC"
      }, "District Of Columbia"), /*#__PURE__*/_react.default.createElement("option", {
        value: "FL"
      }, "Florida"), /*#__PURE__*/_react.default.createElement("option", {
        value: "GA"
      }, "Georgia"), /*#__PURE__*/_react.default.createElement("option", {
        value: "HI"
      }, "Hawaii"), /*#__PURE__*/_react.default.createElement("option", {
        value: "ID"
      }, "Idaho"), /*#__PURE__*/_react.default.createElement("option", {
        value: "IL"
      }, "Illinois"), /*#__PURE__*/_react.default.createElement("option", {
        value: "IN"
      }, "Indiana"), /*#__PURE__*/_react.default.createElement("option", {
        value: "IA"
      }, "Iowa"), /*#__PURE__*/_react.default.createElement("option", {
        value: "KS"
      }, "Kansas"), /*#__PURE__*/_react.default.createElement("option", {
        value: "KY"
      }, "Kentucky"), /*#__PURE__*/_react.default.createElement("option", {
        value: "LA"
      }, "Louisiana"), /*#__PURE__*/_react.default.createElement("option", {
        value: "ME"
      }, "Maine"), /*#__PURE__*/_react.default.createElement("option", {
        value: "MD"
      }, "Maryland"), /*#__PURE__*/_react.default.createElement("option", {
        value: "MA"
      }, "Massachusetts"), /*#__PURE__*/_react.default.createElement("option", {
        value: "MI"
      }, "Michigan"), /*#__PURE__*/_react.default.createElement("option", {
        value: "MN"
      }, "Minnesota"), /*#__PURE__*/_react.default.createElement("option", {
        value: "MS"
      }, "Mississippi"), /*#__PURE__*/_react.default.createElement("option", {
        value: "MO"
      }, "Missouri"), /*#__PURE__*/_react.default.createElement("option", {
        value: "MT"
      }, "Montana"), /*#__PURE__*/_react.default.createElement("option", {
        value: "NE"
      }, "Nebraska"), /*#__PURE__*/_react.default.createElement("option", {
        value: "NV"
      }, "Nevada"), /*#__PURE__*/_react.default.createElement("option", {
        value: "NH"
      }, "New Hampshire"), /*#__PURE__*/_react.default.createElement("option", {
        value: "NJ"
      }, "New Jersey"), /*#__PURE__*/_react.default.createElement("option", {
        value: "NM"
      }, "New Mexico"), /*#__PURE__*/_react.default.createElement("option", {
        value: "NY"
      }, "New York"), /*#__PURE__*/_react.default.createElement("option", {
        value: "NC"
      }, "North Carolina"), /*#__PURE__*/_react.default.createElement("option", {
        value: "ND"
      }, "North Dakota"), /*#__PURE__*/_react.default.createElement("option", {
        value: "OH"
      }, "Ohio"), /*#__PURE__*/_react.default.createElement("option", {
        value: "OK"
      }, "Oklahoma"), /*#__PURE__*/_react.default.createElement("option", {
        value: "OR"
      }, "Oregon"), /*#__PURE__*/_react.default.createElement("option", {
        value: "PA"
      }, "Pennsylvania"), /*#__PURE__*/_react.default.createElement("option", {
        value: "RI"
      }, "Rhode Island"), /*#__PURE__*/_react.default.createElement("option", {
        value: "SC"
      }, "South Carolina"), /*#__PURE__*/_react.default.createElement("option", {
        value: "SD"
      }, "South Dakota"), /*#__PURE__*/_react.default.createElement("option", {
        value: "TN"
      }, "Tennessee"), /*#__PURE__*/_react.default.createElement("option", {
        value: "TX"
      }, "Texas"), /*#__PURE__*/_react.default.createElement("option", {
        value: "UT"
      }, "Utah"), /*#__PURE__*/_react.default.createElement("option", {
        value: "VT"
      }, "Vermont"), /*#__PURE__*/_react.default.createElement("option", {
        value: "VA"
      }, "Virginia"), /*#__PURE__*/_react.default.createElement("option", {
        value: "WA"
      }, "Washington"), /*#__PURE__*/_react.default.createElement("option", {
        value: "WV"
      }, "West Virginia"), /*#__PURE__*/_react.default.createElement("option", {
        value: "WI"
      }, "Wisconsin"), /*#__PURE__*/_react.default.createElement("option", {
        value: "WY"
      }, "Wyoming"), /*#__PURE__*/_react.default.createElement("option", {
        value: "non-us"
      }, "Not a U.S. resident")), /*#__PURE__*/_react.default.createElement("input", {
        type: "submit",
        value: "Join Waitlist",
        id: "joinWaitlist"
      })), /*#__PURE__*/_react.default.createElement("p", null, "By clicking \"Join the waitlist\", you acknowledge reading the", ' ', /*#__PURE__*/_react.default.createElement("a", {
        href: "https://www.wisdomtree.com/investments/privacy-policy",
        target: "_blank",
        rel: "noreferrer"
      }, "privacy policy.")));
    }
  }, {
    key: "renderWaitlistSuccess",
    value: function renderWaitlistSuccess() {
      var ticker = this.props.ticker;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "waitlist-success"
      }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "The form was sent successfully. You will receive updates on the WisdomTree Prime financial app and ", ticker, " availability in your inbox. More information about WisdomTree Prime is available at "), /*#__PURE__*/_react.default.createElement("a", {
        href: "http://www.wisdomtreeprime.com",
        target: "_blank",
        rel: "noreferrer"
      }, "www.wisdomtreeprime.com"), "."));
    }
  }, {
    key: "renderWaitlistLoading",
    value: function renderWaitlistLoading() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "waitlist-loading"
      }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: "circle-notch",
        size: "3x",
        className: "waiting-icon",
        spin: true
      }));
    }

    // Render Digital Funds (wtDivisionID=3)
  }, {
    key: "renderUsDigitalFunds",
    value: function renderUsDigitalFunds() {
      var _this$props3 = this.props,
        ticker = _this$props3.ticker,
        fundName = _this$props3.fundName;
      var _this$state2 = this.state,
        openModal = _this$state2.openModal,
        showWaitlistSuccess = _this$state2.showWaitlistSuccess,
        showWaitlistLoading = _this$state2.showWaitlistLoading;
      var contentToShow = null;

      // Show or hide bits of content - the form or success page
      if (!showWaitlistLoading && !showWaitlistSuccess) {
        contentToShow = this.renderWaitlistForm();
      } else if (showWaitlistLoading) {
        contentToShow = this.renderWaitlistLoading();
      } else if (showWaitlistSuccess) {
        contentToShow = this.renderWaitlistSuccess();
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "buy-fund-app"
      }, ticker !== 'NONE' ? /*#__PURE__*/_react.default.createElement("div", {
        className: "trade-fund"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.handleOpenModal
      }, "HOW TO BUY", ' ', ticker.toUpperCase()), /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
        open: openModal === true,
        showCloseIcon: true,
        onClose: this.handleCloseModal,
        focusTrapped: false,
        classNames: {
          overlay: 'modal-overlay',
          modal: 'choose-broker-container'
        },
        closeOnOverlayClick: true,
        closeOnEsc: true,
        center: true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "choose-broker"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "intro"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "How to Buy ", ticker.toUpperCase(), "?"), /*#__PURE__*/_react.default.createElement("p", null, "The", ' ', fundName, ' ', "will be available exclusively through the new WisdomTree Prime financial app, targeted for launch later this year."), contentToShow), /*#__PURE__*/_react.default.createElement("div", {
        className: "footnotes"
      }, /*#__PURE__*/_react.default.createElement("p", null))))) : null);
    }

    // Render the app
  }, {
    key: "render",
    value: function render() {
      var wtDivisionID = this.props.wtDivisionID;
      switch (wtDivisionID) {
        case WT_DIVISIONS.US:
          return this.renderUsEtfs();
        case WT_DIVISIONS.USDigital:
          return this.renderUsDigitalFunds();
        default:
          return this.renderUsEtfs();
      }
    }
  }, {
    key: "renderCompareButton",
    value: function renderCompareButton() {
      var ticker = this.props.ticker;
      var fundExists = this.state.fundExists;

      // Render the button if the fund exists in dataspane
      var compareButton = null;
      if (fundExists) {
        compareButton = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
          onClick: this.handleCompareClick,
          "data-tip": true,
          "data-for": "compare-tool-tip"
        }, "COMPARE", ' ', ticker.toUpperCase()), /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
          id: "compare-tool-tip",
          type: "light",
          className: "tooltip",
          effect: "float"
        }, "Compare funds and benchmark indexes based on fundamental characteristics, exposures, performance, and more."));
      }
      return compareButton;
    }

    /// Check the fund actually exists in dataspan api (MongoDB)
  }, {
    key: "checkFundExists",
    value: function () {
      var _checkFundExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$props4, ticker, dataspanApiUrl, wtRegion, request, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props4 = this.props, ticker = _this$props4.ticker, dataspanApiUrl = _this$props4.dataspanApiUrl, wtRegion = _this$props4.wtRegion;
                if (ticker) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                request = {
                  method: 'GET',
                  url: "".concat(dataspanApiUrl, "/fundchar/typeahead/"),
                  params: {
                    q: ticker,
                    wtRegion: wtRegion
                  }
                };
                _context.prev = 4;
                _context.next = 7;
                return (0, _axios.default)(request);
              case 7:
                response = _context.sent;
                if (response.status === 200) {
                  this.setState({
                    fundExists: true
                  });
                }
                _context.next = 15;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                // If the fund doesn't exist the app won't load
                if (_context.t0.response.status === 404) {
                  this.setState({
                    fundExists: false
                  });
                }
                console.log(_context.t0);
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11]]);
      }));
      function checkFundExists() {
        return _checkFundExists.apply(this, arguments);
      }
      return checkFundExists;
    }()
  }]);
  return BuyFund;
}(_react.PureComponent);
_defineProperty(BuyFund, "defaultProps", {
  brokers: _brokers.default,
  dataspanApiUrl: 'https://dataspanapi.wisdomtree.com',
  ticker: '',
  showCompare: true,
  showCompetitors: true,
  wtRegion: 'US',
  wtDivisionID: 1,
  fundName: ''
});
var _default = BuyFund;
exports.default = _default;